import refreshCaptcha from "../utils/captcha-refresh";
const ppCaptcha = document.querySelector('.pp-captcha__input-wrapper');

if(undefined!==ppCaptcha){
    refreshCaptcha('.pp-captcha__code-refresh', '.pp-captcha__code-img');
}